module.exports = __webpack_public_path__ + "img/w3_translate_black.9ab0fcf5.png";